import router from './router'
import store from './store'
import { getToken } from './utils/auth'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const WHITE_LIST = ['/login']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const token = getToken()

  // 未登录
  if (!token) {
    if (WHITE_LIST.includes(to.path)) return next()
    return next('/login')
  }

  // 已登录访问登录页
  if (to.path === '/login') {
    NProgress.done()
    if (!store.getters.menus.length) await loadRoutes()
    return next('/dashboard')
  }

  // 动态路由未加载（用 menus 是否有数据判断）
  if (!store.getters.menus.length) {
    try {
      await loadRoutes()
      return next({ ...to, replace: true })
    } catch (e) {
      await store.dispatch('user/logout')
      return next('/login')
    }
  }

  next()
})

router.afterEach(() => NProgress.done())

let routesAdded = false

async function loadRoutes() {
  const data = await store.dispatch('user/getInfo')
  if (!routesAdded) {
    const dynamicRoutes = buildRoutes(data.menus)
    router.addRoutes(dynamicRoutes)
    routesAdded = true
  }
}

function buildRoutes(menus) {
  const routes = [
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import('./views/dashboard/index.vue'),
      meta: { title: '首页' }
    }
  ]


  function collectRoutes(menuList) {
    menuList.forEach(menu => {
      if (menu.menuType === 1 && menu.component) {
        // 页面菜单，注册路由（子菜单path即为全路径，不拼接父菜单path）
        routes.push({
          path: menu.path,
          component:() => import('./views/'+menu.component+'.vue') || (() => import('./views/dashboard/index.vue')),
          meta: { title: menu.menuName, icon: menu.icon }
        })
      } else if (menu.menuType === 0 && menu.children && menu.children.length) {
        // 目录菜单，递归处理子菜单
        collectRoutes(menu.children)

      }
    })
  }

  collectRoutes(menus, '')
     //拼接 菜单;
   //console.log("菜单集合",routes);

  return [
    {
      path: '/',
      component: () => import('./views/layout/Layout.vue'),
      redirect: '/dashboard',
      children: routes
    },
    { path: '/404', component: () => import('./views/404.vue') },
    { path: '*', redirect: '/404' }
  ]
}


// ===================== 【对外导出：刷新菜单方法，极简】 =====================
export async function refreshMenu() {

  console.log("设计中,更新菜单...");
  routesAdded = false
  // 清空vuex菜单
  store.commit('user/SET_MENUS', [])
  // 重新拉菜单+构建路由
  await loadRoutes()
  // 刷新当前路由，侧边栏更新
  router.replace({ ...router.currentRoute })
}
// =========================================================================